export enum ParameterTypeEnum {
  QuoteId = 1,
  ContractNumber,
  Vin,
  AdjustmentId,
  EliteActivationAmount,
  CapturedDownPaymentAmount,
  AlteredDownPaymentAmount,
  RewriteDisabledDays,
  PlanName,
  DealerContractSource,
}
